import { dashboardApi } from "@api";
import { useEffect, useState } from "react";
import {
  IChartCoupon,
  IClientInfo,
  IClinicCoupon,
  IClinicHcp,
  ICouponVisualData,
} from "@interfaces";
import { useSelector } from "react-redux";
import { selectApp } from "@redux";
import { PATH_CDIC_COUPON_REDEEM, PATH_HOME, PATH_MY_PROFILE, PATH_OTP, PATH_REDEEM_COUPON, enumJoinedProgram, enumSubdomain } from "@configs";
import { useHistory, useLocation } from "react-router";

interface IReturn {
  data: ICouponVisualData;
  loading: boolean;
}
interface IParams {
  type?: string;
}
const init = {
  todayCouponInfo: {},
  patientCount: {},
  couponInfo: {},
};
export const useCouponCount = ({ type = "" }: IParams): IReturn => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<ICouponVisualData>(init);
  useEffect(() => {
    fetchData();
  }, ["fetchCouponCount", type]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await dashboardApi.couponCount({ type });
      setData(res?.data?.data);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      // warning(err.message);
    }
  };
  return { data, loading };
};
interface IParamRegion {
  region: string;
}
export const useCouponInfo = ({
  region,
}: IParamRegion): { data: IChartCoupon[]; loading: boolean } => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IChartCoupon[]>([]);
  useEffect(() => {
    fetchData();
  }, ["fetchCouponInfo", region]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await dashboardApi.couponInfo({ region });
      setData(res?.data?.data);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      // warning(err.message);
    }
  };
  return { data, loading };
};

export const useClientInfo = (): { data: IClientInfo[]; loading: boolean } => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IClientInfo[]>([]);
  useEffect(() => {
    fetchData();
  }, ["fetchCouponInfo"]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await dashboardApi.clientAgeInfo();
      setData(res?.data?.data);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      // warning(err.message);
    }
  };
  return { data, loading };
};

export const useclinicGraph = ({
  region,
}: {
  region: string;
}): { data: IClinicCoupon[]; loading: boolean } => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IClinicCoupon[]>([]);
  useEffect(() => {
    fetchData();
  }, ["fetchCouponInfo", region]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await dashboardApi.clinicGraph({ region });
      setData(res?.data?.data);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      // warning(err.message);
    }
  };
  return { data, loading };
};

export const checkPermissions = () => {
  const { domain, program } = useSelector(selectApp);
  const history = useHistory();
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname !== PATH_OTP) redirectFun();
  }, [domain, pathname]);

  const redirectFun = async () => {
    // return;
    if (domain === enumSubdomain.CLINIC || domain === enumSubdomain.STG_CLINIC) {
      await history.push(PATH_MY_PROFILE);
    } else {
      await history.push(PATH_HOME);
    }
  };
};
export const useclinicHcp = (): { data: IClinicHcp | undefined; loading: boolean } => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IClinicHcp>();
  useEffect(() => {
    fetchData();
  }, ["fetchCouponHcp"]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await dashboardApi.clinicHcpCount();
      setData(res?.data?.data);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      // warning(err.message);
    }
  };
  return { data, loading };
};
